const data = [
	{
		Spoken: `Completed One week Faculty Development Program on “ R Programming”`,
	},
	{
		Spoken: `Completed One week Faculty Development Program on “ R Programming”`,
	},
	{
		Spoken: `Completed One week Faculty Development Program on “ Bio Python”`,
	},
	{
		Spoken: `Completed Two week Faculty Development Program on “ RProgramming”`,
	},
	{
		Spoken: `Completed One week Faculty Development Program on “ DRUPAL”`,
	},
];

export default data;
